import React, { Component } from 'react';
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { formatDate, formatTime, convertTo12HourFormat, getHoursAndMinutes, isNegativeDeviation, TextBox, GetCurrentMonthStartEndDates, SubmitButton } from '../../Components/InputElements';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import Select from 'react-select';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime,decodeData, formatDateAndTime, getFullYearMonthArray, tableFormatDateAndTime, getMonthCycleStartDate, getNextMonthIfDayExceeds20 } from '../../Constants/constants';


class MyRegularization extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_id: 0,
            employee_attendance_id: 0,
            attendance_regularization_request_id: 0,
            remark_by_manager: '',
            punch_in_datetime: "",
            punch_out_datetime: "",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            loadingFilter: false,
            keyword: "",
            from_date: "",
            to_date: "",
            selectOption: "",
            selectedRows: [],
            month: null,
            startDay: null,
            monthOptions: [],
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }


    // componentDidMount() {
    //     this.setState({ loadingList: true }, (prevState) => {
    //         this.SetDates();
    //         this.GetList();
    //     });
    //     let date=currentDateAndTime();
    //     let monthOpt= getFullYearMonthArray(date);
    //     this.setState({ monthOptions:monthOpt});
    // }

    async componentDidMount() {
        this.setState({ loadingList: true }, async () => {
            try {
                await this.SetDates();
                await this.GetMonthFilterList();
                let date= getMonthCycleStartDate(currentDateAndTime(),this.state.startDay);
                let currMonth= getNextMonthIfDayExceeds20(date);
                // console.log("componentDidMount ~ currMonth",currMonth);
                this.setState({ month:currMonth});
                // await this.GetList();
            } catch (error) {
                console.error('An error occurred in component mounnting:', error);
            } finally {

                this.setState({ loadingList: false });
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

    GetMonthFilterList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetMonthYearFilterList`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                if (data?.success === true) {

                    const currentMonth = Array.isArray(data?.filterArray) && data?.filterArray?.length>0 ? data?.filterArray[0]?.value : "";

                    this.setState({
                        loadingList: false,
                        monthOptions: data?.filterArray,
                        month: currentMonth || null, 
                        startDay: data?.month_cycle_start_date,
                    },()=> this.GetList());

                } else {
                    this.setState({ loadingList: false },()=> this.GetList());
                }
            })
            .catch((error)=>{
                this.setState({ loadingList: false },()=> this.GetList());
            });
    };

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let date = currentDateAndTime();
        axios.get(`${apiURL}Attendance/GetTeamRegularizationReport`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month || new Date()?.getMonth(),
                regularization_status: this.state.selectOption,
                employee: 1,
                date: date

            },
            headers,
        }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                });
            }
            this.setState({ loadingList: false, loadingFilter: false });
        })
        .catch((error)=>{
            this.setState({ loadingList: false, loadingFilter: false });
            Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: error?.message, 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
            });
        });
    };

    SetDates = () => {
        const { startOfMonth, endOfMonth } = GetCurrentMonthStartEndDates();
        this.setState({
            from_date: startOfMonth,
            to_date: endOfMonth,
        }, () => {
            this.GetList();
        });
    }

    getCurrentMonth = () => {
        const currentDate = currentDateAndTime()?.split(" ")[0];
        const currentMonth = currentDate?.split("-")[1];
        return currentMonth;
    };

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Attendance/GetTeamRegularizationReport`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month || new Date()?.getMonth(),
                regularization_status: this.state.selectOption,
                employee: 1,
                date: currentDateAndTime(),
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;

                const data = rows.map(row => ({
                    'Requested Date': row.created_date?formatDate(row.created_date):"--",
                    'Requested Punch In': JSON.parse(row.regularization_request_remark)?.punch_in_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12) : "--",
                    'Requested Punch Out': JSON.parse(row.regularization_request_remark)?.punch_out_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12) : "--",
                    'Actual Punch In': row.actual_punch_in_datetime ? tableFormatDateAndTime(row.actual_punch_in_datetime, 12) : "--",
                    'Actual Punch Out': row.actual_punch_out_datetime ? tableFormatDateAndTime(row.actual_punch_out_datetime, 12) : "--",
                    'Shift': convertTo12HourFormat(row.shift_start_time) + " - " + convertTo12HourFormat(row.shift_end_time),
                    'Working Hours':row.working_hours ? getHoursAndMinutes(row.working_hours) : "--",
                    'Deviation': row.deviation && row.deviation !== "NaN" ? getHoursAndMinutes(row.deviation) : "--",
                    'Regularization Status': row.regularizationRequestStatus?row.regularizationRequestStatus:"--",
                    'Reason': row.remark_by_employee?row.remark_by_employee:"--",
                    'Remark': row.regularized_by_remark?row.regularized_by_remark:'--',
                }));


                const columns = [
                    { header: 'Requested Date', key: 'Date', width: 20 },
                    { header: 'Requested Punch In', key: 'Requested Punch In', width: 15 },
                    { header: 'Requested Punch Out', key: 'Requested Punch In', width: 15 },
                    { header: 'Actual Punch In', key: 'Actual Punch In', width: 15 },
                    { header: 'Actual Punch Out', key: 'Actual Punch Out', width: 15 },
                    { header: 'Shift', key: 'Shift', width: 20 },
                    { header: 'Working Hours', key: 'Working Hours', width: 20 },
                    { header: 'Deviation', key: 'Deviation', width: 20 },
                    { header: 'Regularization Status', key: 'Regularization Status', width: 20 },
                    { header: 'Reason', key: 'Reason', width: 40 },
                    { header: 'Remark', key: 'Remark', width: 40 },
                ];


                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'AbStart My Regularization');


                // XLSX.writeFile(wb, `AbStartMyRegularization_(${Date()}).xlsx`);
                const date = new Date();
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();

                XLSX.writeFile(wb, `AbStartMyRegularization_(${formatDate(dateString)} ${timeString}).xlsx`);


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                // Close the Swal alert if there is an error
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }

    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            employee_attendance_id: 0,
            employee_id: 0,
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }

    handleInputSearch = (e) => {
        this.GetList();
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page - 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleNext = () => {
        if (this.state.next === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page + 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleChange = (e) => {
        this.setState(
            (prevState) => {
                return { page: parseInt(e.target.value, 10) };
            },
            () => {
                this.GetList();
            }
        );
    };

    handleSelectStatus = (selectedOption) => {
        this.setState({ selectOption: selectedOption.value, });
    };


    handleClearAll = () => {
        try {
            let filterArray = this.state.monthOptions;
            console.log("filterArray in clear", filterArray);
            // Extract current month from your logic
            const currentMonth = parseInt(this.getCurrentMonth(), 10);

            // Find the corresponding month option based on the current month
            const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);
            this.setState(
                {
                    rows: [],
                    next: false,
                    prev: false,
                    page: 1,
                    limit: 10,
                    total_records: 0,
                    total_pages: 0,
                    loadingList: false,
                    postLoading: false,
                    from_date: "",
                    to_date: "",
                    selectOption: "",
                    // month: `${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1])}-${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[0])}`,
                    // month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
                    month: defaultMonthOption ? defaultMonthOption.value : null,
                },
                () => {
                    this.GetList();
                }
            );
        } catch (error) {
            this.setState({ loadingFilter: false });
        }
    };

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];

        const options = [
            { value: '0', label: 'Pending' },
            { value: '1', label: 'Regularized' },
            // { value: '2', label: 'Auto Regularized' },
            // { value: '3', label: 'Regularized Rejected' },
        ];


        return (

            this.state.loadingList === false ?
                (<div className="main-content">
                    <div className='page-content'>
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`My Regularization`} primary={`My Details`} />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                {/* <div style={{width:"20%"}} className='col-md-3'>
                                                    <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                </div>
                                                <div style={{width:"20%"}} className='col-md-3'>
                                                    <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                </div> */}
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Month</label></div>
                                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                        options={this.state.monthOptions}
                                                        placeholder={`Select Month`}
                                                        value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}/>
                                                    </div>
                                                </div>
                                                <div className='col-md-3 position-relative mb-5'>
                                                    <div><label>Status</label></div>
                                                    <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={this.handleSelectStatus}
                                                        options={options}
                                                        placeholder={`Select Status`}
                                                        value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}/>
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-6'>
                                                    <div className="row"> */}
                                                <div className='col-lg-2 col-md-3 col-6' >
                                                    <div><label>Apply Filter</label></div>
                                                    {/* <button onClick={this.handleInputSearch}
                                                        className={`w-100 btn btn-info btn-label waves-effect waves-light`}
                                                        type="button">
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                    disabled={!this.state.keyword && !this.state.month && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                                                    loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                    buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                </div>
                                                <div className='col-lg-2 col-md-3 col-6' >
                                                    <div><label>Clear Filter</label></div>
                                                    {/* <button onClick={this.handleClearAll}
                                                        className={`btn btn-secondary btn-label waves-effect waves-light noWrap w-100 ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '') ? 'disabled' : ''}`}
                                                        type="button">
                                                        <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> 
                                                        Clear
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                    disabled={!this.state.keyword && !this.state.month && !this.state.from_date && !this.state.selectOption && !this.state.to_date}
                                                    loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                    buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                </div>
                                                { this.state.decodedData?.includes(6) && ( 
                                                <div className='col-lg-2 col-md-3 col-6' >
                                                    <div>
                                                        <label>Export Excel</label>
                                                    </div>
                                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleExcelDownload}
                                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        Export Excel
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                    disabled={this.state.rows.length === 0}
                                                    buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                </div>)}
                                                    {/* </div>
                                                </div> */}
                                            </div>
                                            {/* <div className="row mt-3">
                                                <div className='col-md-3'>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <div>
                                                                <label>Export Excel</label>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={this.handleExcelDownload}
                                                                className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                Export Excel
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div> */}
                                        </div>
                                        {/* style={{ width: '235%', minWidth: '600px' }} */}
                                        <div className="card-body">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                <table className={` position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-left`}>
                                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Application Date</th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Requested Punch In</th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Requested Punch Out</th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Actual Punch In</th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Actual Punch Out</th>
                                                            <th width="100" className=' text-center'>Shift </th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Working Hours</th>
                                                            {/* <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Deviation</th> */}
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Status</th>
                                                            <th width="100" style={{ textWrap: "nowrap" }} className=' text-center'>Regularization Type</th>
                                                            <th width="100" className=' text-center'>Reason</th>
                                                            <th width="100" className=' text-center'>Remark</th>
                                                        </tr>
                                                    </thead>
                                                    {this.state.rows.length === 0 ? (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={14}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) :
                                                        <tbody>
                                                            {this.state.rows.map((row) => {
                                                                return (
                                                                    <tr key={row.employee_attendance_id}>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{formatDate(row.created_date)}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{JSON.parse(row.regularization_request_remark)?.punch_in_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{JSON.parse(row.regularization_request_remark)?.punch_out_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.actual_punch_in_datetime ? tableFormatDateAndTime(row.actual_punch_in_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.actual_punch_out_datetime ? tableFormatDateAndTime(row.actual_punch_out_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{convertTo12HourFormat(row.shift_start_time) + ", " + convertTo12HourFormat(row.shift_end_time)}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.working_hours ? getHoursAndMinutes(row.working_hours) : "--"}</td>
                                                                        {/* <td style={{ textWrap: "nowrap" }} className=' text-center'>
                                                                            <span className={isNegativeDeviation(row.deviation) ? 'text-danger' : ''}>{row.deviation && row.deviation !== "NaN" ? getHoursAndMinutes(row.deviation) : "--"}</span>
                                                                        </td> */}
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'><span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus?row.regularizationRequestStatus:"--"}</span></td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.regularizationType?row.regularizationType:"--"}</td>
                                                                        <td className={`${row.remark_by_employee?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row.remark_by_employee?row.remark_by_employee:'--'}</td>
                                                                        <td className={`${row.regularized_by_remark?.length >= 30 ? "textEllipse" : "noWrap"}`} >{row.regularized_by_remark?row.regularized_by_remark:"--"}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>}


                                                </table>
                                            </div>
                                            {/* <div className="d-flex justify-content-between align-items-center w-100 p-2">
                                                <button
                                                    disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                                                    type="button"
                                                    onClick={() => this.handlePrev()}
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button>
                                                <div
                                                    className="col-md-4"
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    {
                                                        <small>
                                                            Total Records: {this.state.total_records} |
                                                            Total Pages: {this.state.total_pages} |
                                                            Current Page: {this.state.page}
                                                        </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                        className="form-select"
                                                        onChange={(e) => this.handleChange(e)}
                                                    >
                                                        {Array.from(
                                                            { length: this.state.total_pages },
                                                            (_, i) => (
                                                                <option
                                                                    selected={this.state.page === i + 1}
                                                                    key={i}
                                                                    value={i + 1}
                                                                >
                                                                    Page {i + 1}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>
                                                                Limit {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div><button
                                                    disabled={
                                                        this.state.next === false &&
                                                            this.state.loadingList === false
                                                            ? true
                                                            : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handleNext()}
                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

        );
    }
}

export default withRouter(MyRegularization);
